export default __webpack_public_path__ + "static/media/bell-empty-black.3c68bfd0.svg";